import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs';

/** Infinite scroll pagination service. */
@Injectable()
export class InfiniteScrollPaginationService {
  private readonly _haveNextPage$ = new BehaviorSubject(true);

  private readonly _isPageLoading$ = new BehaviorSubject(false);

  /** Can paginate. */
  public readonly canPaginate$ = this.initializeCanPaginate();

  /**
   * Set have next page.
   * @param haveNextPage Have next page.
   */
  public setHaveNextPage(haveNextPage: boolean): void {
    this._haveNextPage$.next(haveNextPage);
  }

  /**
   * Set is page loading.
   * @param isPageLoading Is page loading.
   */
  public setIsPageLoading(isPageLoading: boolean): void {
    this._isPageLoading$.next(isPageLoading);
  }

  private initializeCanPaginate(): Observable<boolean> {
    return combineLatest([
      this._isPageLoading$,
      this._haveNextPage$,
    ]).pipe(

      /** Continue paginate if we are not currently getting next page and we have the next page. */
      map(([isNextLoading, haveNextPage]) => !isNextLoading && haveNextPage),
    );
  }
}
